import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';
import CustomerSurvey from 'views/frontend/customer-survey-responses/guest';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/authentication1/Login1')));
// const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
// const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ForgotPassword3')));
const PagesContactUS = Loadable(lazy(() => import('views/frontend/complaints/form-complaints')));
const MemberRegister = Loadable(lazy(() => import('views/frontend/member_register/guest')));
const MemberRegisterNew = Loadable(lazy(() => import('views/frontend/member_register_new/guest')));
// const MemberRegister2 = Loadable(lazy(() => import('views/frontend/member_register/guest')));
const MaintenanceError = Loadable(lazy(() => import('views/pages/maintenance/Error')));
const VatRegister = Loadable(lazy(() => import('views/frontend/vat_info/guest')));
const GoodDeliveryRegister = Loadable(lazy(() => import('views/frontend/goods_delivery/guest')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/backoffice/login',
            element: <AuthLogin />
        },
        {
            path: '/*',
            element: <MaintenanceError />
        },
        {
            path: '/feedback',
            element: <PagesContactUS />
        },
        {
            path: '/member-registration',
            element: <MemberRegister />
        },
        {
            path: '/member_registration',
            element: <MemberRegister />
        },
        {
            path: '/member-registration-new',
            element: <MemberRegisterNew />
        },
        {
            path: '/vat-registration',
            element: <VatRegister />
        },
        // {
        //     path: '/customer-survey',
        //     element: <CustomerSurvey />
        // },
        {
            path: '/good-delivery-registration',
            element: <GoodDeliveryRegister />
        }
    ]
};

export default LoginRoutes;
